import React from 'react'
import { withRouter } from "react-router-dom";
import { TableOp } from '../../../components/table/TableOps.tsx';
import TableComponent from '../../../components/table/TableOps';
import ControlDeposito from './ControlDeposito'
import ACCESS from '../../../ACCESS.js';

class ControlDepositos extends TableComponent {

  componentDidMount() {
    this.tableConfig(
      { dataUrl: 'pago/filter', deleteUrl: 'pago/delete', deleteField: 'cuenta', modUrl: '/Cobranza/DepositosDetalle' },
      TableOp.Table('Depositos', [
        { label: 'Folio', id: 'id' },
        { label: 'Cuenta', id: 'cuenta' },
        { label: 'Fecha Deposito', id: 'fecha_deposito' },
        { label: 'Usuario', id: 'usuario' },
      ], [
        { id: 'edit', icon: 'edit', access: [ACCESS.COBRANZA_CONTROL_DEPOSITO.VER_DEPOSITOS_CREADOS_POR_EL_USUARIO, ACCESS.COBRANZA_CONTROL_DEPOSITO.VER_TODOS_LOS_DEPOSITOS] },
        // { id: 'delete', icon: 'delete' },
      ]))
    this.table();
  }

  render() {
    const { hasAccess } = this.context;
    return (
      <div>
        <div>
        { hasAccess(ACCESS.COBRANZA_CONTROL_DEPOSITO.CREAR_DEPOSITO) &&
          <ControlDeposito onSave={() => {this.table()}} />
        }
        <this.TableRender />
        </div>
      </div>
    )
  }
}

export default withRouter(ControlDepositos)